/**
 * Captain Mesh Network State Machine
 * 
 * Exposes a clean application-level interface for the UI to consume,
 * without leaking WebRTC or WebSocket implementation details.
 */

export const NetworkMode = {
  SERVER_CONNECTED: "SERVER_CONNECTED",
  SERVER_DEGRADED: "SERVER_DEGRADED",
  SERVER_OFFLINE: "SERVER_OFFLINE",
  MESH_CONNECTING: "MESH_CONNECTING",
  MESH_ACTIVE: "MESH_ACTIVE",
  MESH_DEGRADED: "MESH_DEGRADED",
  LOCAL_ONLY: "LOCAL_ONLY",
  RECONCILING: "RECONCILING"
};

class NetworkStateManager {
  constructor() {
    this.mode = NetworkMode.SERVER_CONNECTED;
    this.listeners = new Set();
  }

  setMode(newMode) {
    if (this.mode !== newMode) {
      this.mode = newMode;
      this.notifyListeners();
    }
  }

  getMode() {
    return this.mode;
  }

  subscribe(callback) {
    this.listeners.add(callback);
    callback(this.mode); // Immediate initial notification
    return () => this.listeners.delete(callback);
  }

  notifyListeners() {
    for (const callback of this.listeners) {
      callback(this.mode);
    }
  }
}

export const networkState = new NetworkStateManager();

// Diagnostic handle, same spirit as window._meshDevtools: the e2e suite polls
// the current mode to know when failover really happened. Harmless in
// production (read-only singleton), invaluable in a failing trace.
if (typeof window !== "undefined") {
  window.__networkState = networkState;
}
